import { WebhookEvents } from "./Enums";

export const WebhookEventDefinitions = [
  {
    label: "Cases",
    value: WebhookEvents.CASES,
  },
  {
    label: "Evidence",
    value: WebhookEvents.EVIDENCE,
  },
  {
    label: "Storage",
    value: WebhookEvents.STORAGE,
  },
  {
    label: "Acquisitions",
    value: WebhookEvents.ACQUISITIONS,
  },
  {
    label: "Tasks",
    value: WebhookEvents.TASKS,
  },
  // {
  //   label: "Documents",
  //   value: WebhookEvents.DOCUMENTS,
  // },
  {
    label: "Time Entries",
    value: WebhookEvents.TIME_ENTRIES,
  },
];
